<template>
<BaseDialog
        :showDialog="showExportSheetsDialog"
        maxDialogWidth="750"
        maxCardHeight="800"
        headline="lang_GENERIC_CAPTION_EXPORT"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>

            <v-container v-if="allowExport === false">
                <v-row>
                    <v-col alvqa="action-export-film-tv-notice">{{ $t("lang_PUBLISHING_SHEETS_ACTION_EXPORT_FILMTV_NOTICE") }}</v-col>
                </v-row>
            </v-container>

            <v-container v-else fluid>
                <v-row>
                    <v-col cols="12">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="Type" 
                                :items="typeItems" 
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-type'"
                            />
                                <!-- :additionalFunction="clearButtons" -->
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid >
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        
                        <span>
                            <BaseButton 
                                label="lang_BUTTON_START"
                                @click="start"
                                :disabled="isLoading || allowExport === false"
                                :alvqa="alvqa+'-button-start'"
                            />
                        </span>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
  
</template>

<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'


export default {
    name:'ExportSheetsDialog',
    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageDropdown,
  
    },

    data() {
        return {
            context: "ExportSheets",
            alvqa: 'publishing-sheets-list-dialog-export-sheets'
        }
    },

    computed: {
        showExportSheetsDialog: {
            get() { return this.$store.getters.getShowExportSheetsDialog },
            set(show) { this.$store.commit('setShowExportSheetsDialog', show) }
        },
        isLoading()     { return this.$store.getters.getIsLoading },
        typeItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_ACTION_EXPORT_DIALOG_TYPE_CONCERT_DATE_NOTIFICATION'), 
                    value: 'concert', 
                    alvqa: this.alvqa + '-dropdown-type-concert-date-notification',
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_ACTION_EXPORT_DIALOG_TYPE_SETLIST'), 
                    value: 'setlist', 
                    alvqa: this.alvqa + '-dropdown-type-setlist'
                }
            ]
        },
        allowExport(){
            let selectedSheetAlvId = this.$store.getters.getSelectedSheets.length !== 0 ? this.$store.getters.getSelectedSheets[0] : ''
            let allSheets = this.$store.getters.getSheets

            if(selectedSheetAlvId !== '' && selectedSheetAlvId !== undefined && selectedSheetAlvId !== null){

                let item = allSheets.find(sheet => sheet.alvId === selectedSheetAlvId)

                if(item.type === "film/tv" || item.type === undefined || item.type === null){
                    return false
                }else{
                    return true
                }
            }
            
        }
    },

    methods: {
        closeDialog() {
            this.showExportSheetsDialog = false
            this.clearButtons()
        },
        clearButtons() {
            this.$store.commit('setExportSheetsDetailsType',[])
        },
        start() {
            this.$store.dispatch('exportSelectedSheets')
        },
    },
}
</script>

<style>

</style>